<template>
  <div class="text-center">
    <v-bottom-sheet v-model="visible">
      <v-sheet class="text-center" height="200px">
        <div style="position:relative;padding-top:0.8rem;">
            <span>
              <span>安全验证</span>
            </span>
            <span style="position:absolute;right:10px;top:10px;"><v-icon size="27" @click="visible=false">mdi-close</v-icon></span>
        </div>
        <div style="font-size:0.85rem;padding-top:1rem;">请输入 {{confirmCode}} 进行验证</div>
        <div style="margin-top:0.5rem;">
            <v-row>
                <v-col :cols="12">
                  <v-text-field hide-details style="width:9rem;font-size:0.95rem;display: inline-block;" v-model="verifyCode" placeholder="请输入6位验证码" dense></v-text-field>
                </v-col>
            </v-row>
            <v-btn style="width:80%;margin-top:0.5rem;" color="#409EFF" dark @click="onSubmit" large>确定</v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <ConfirmDialog :visible.sync="confirmDialogVis" headColor="warning" title="提示" :content="confirmContent" />
  </div>
</template>

<script>
import ConfirmDialog from './ConfirmDialog.vue'
export default {
  components: { ConfirmDialog },
  props: {},
  data() {
    return {
      visible: false,
      verifyCode: '',
      confirmCode: '',
      confirmDialogVis: false,
      confirmContent: ''
    }
  },
  computed: {},
  async mounted() {
    this.init()
  },
  created() {
  },
  methods: {
    show() {
      var that = this
      that.init()
      that.visible = true
    },
    close() {
      this.visible = false
    },
    // 初始化
    async init() {
      var that = this
      that.verifyCode = ''
      that.confirmCode = that.$util.randomInt(6)
    },
    // 确定提交
    async onSubmit() {
      var that = this
      if (!that.verifyCode || that.verifyCode === '') {
        // that.$toast.warning('请输入6位验证码')
        that.confirmContent = '请输入6位验证码'
        that.confirmDialogVis = true
        return
      }
      if (that.verifyCode.length !== 6) {
        // that.$toast.warning('请输入正确验证码')
        that.confirmContent = '请输入正确验证码'
        that.confirmDialogVis = true
        return
      }
      if (that.confirmCode !== that.verifyCode) {
        // that.$toast.warning('请输入正确验证码')
        that.confirmContent = '请输入正确验证码'
        that.confirmDialogVis = true
        return
      }
      // 安全验证通过
      that.$emit('verifyed')
      that.close()
    }
  }
}
</script>

<style scoped>
</style>

